/* jshint node:true */

/**
 * browser.js
 * A small utility to interact with the browser APIs
 * @author: Nihar Kabinittal
 */

/**
 * Gets a particular key / variable
 * from a given path in an Object
 * @param  {String} path
 * @param  {Object} scope
 * @return       
 */
function get(path, scope) {
    try{
        var cur = scope || window;
        var parts = path.split('.');

        for (var part; parts.length && (part = parts.shift());) {
            if (!parts.length || cur[part]) {
                cur = cur[part] || null;
            }

        }
        return cur;
    }catch(e){}
    return null;
}

/**
 * Sets a property to an Object
 * @param {String} path  Path of the Object
 * @param {String} prop  Property to be set
 * @param value to be set
 */
function set(path, prop, value) {
    try{
        var cur = get(path);
        cur[prop] = value;
        return cur[prop];
    }catch(e){}
    return false;
}

/**
 * Executes the method with a set of arguments
 * @param  {String} path Path to the method
 * @param  {Array} args Arguments to be passed
 * @return {Function/Boolean}      True if function executes
 */
function call(path, args) {
    try{
        var cur = get(path);
        if (typeof cur === 'function') {
            return cur.apply(this, args);
        }
    }catch(e){}
    return false;
}

/**
 * Expose the module
 * @type {Object}
 */
module.exports = {
    get: get,
    set: set,
    call: call
};


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/helpers/utils/browser.js
 **/